import { Dispatch, useEffect, useState } from "react"
import { CiCircleRemove } from 'react-icons/ci';
import { TPlayer, Input, Heading } from '@sifrovacihra/shared-ui'
import { isValidEmail, isValidFullName, notEmptyString } from "../../utils"


type PlayerProps = {
    player: TPlayer,
    ord: number,
    emailRequired: boolean,
    showErrors: boolean,
    players: TPlayer[],
    setPlayers: Dispatch<React.SetStateAction<TPlayer[]>>,
    removePlayer: (id: number) => void
}

export const Player = ({ player, ord, emailRequired, showErrors, setPlayers, players, removePlayer }: PlayerProps) => {
    const [nameError, setNameError] = useState('')
    const [emailError, setEmailError] = useState('')
    const [ageError, setAgeError] = useState('')

    useState(() => {
        console.log('player rendered')
        console.log(player)
    })

    const setPlayerName = (v: string) => {
        let updatedList = players.map(item => {
            if (item.Id === player.Id) {
                return { ...item, Name: v };
            }
            return item;
        });
        setPlayers(updatedList)
    }

    const setPlayerFullName = (v: string) => {
        let updatedList = players.map(item => {
            if (item.Id === player.Id) {
                return { ...item, FullName: v };
            }
            return item;
        });
        setPlayers(updatedList)
    }

    const setEmail = (v: string) => {
        let updatedList = players.map(item => {
            if (item.Id === player.Id) {
                return { ...item, Email: v };
            }
            return item;
        });
        setPlayers(updatedList)
    }

    const setAge = (v: string) => {
        let a: number | undefined = undefined
        setAgeError('')
        if (v.length > 0) {
            a = parseInt(v.toString())
            if (isNaN(a)) {
                setAgeError('Věk musí být číslo!')
                a = undefined
            }
        }
        player.Age = a
        let updatedList = players.map(item => {
            if (item.Id === player.Id) {
                return { ...item, Age: a };
            }
            return item;
        });
        setPlayers(updatedList)
    }

    const setCity = (v: string) => {
        let updatedList = players.map(item => {
            if (item.Id === player.Id) {
                return { ...item, City: v };
            }
            return item;
        });
        setPlayers(updatedList)
    }

    useEffect(() => {
        setNameError('')
        setEmailError('')
        if (showErrors) {
            if (!isValidFullName(player.FullName || '')) {
                setNameError('Zadejte plné jméno hráče')
            }
            if (emailRequired && !notEmptyString(player.Email)) {
                setEmailError('Zadejte email')
            }
            if (player.Email && !isValidEmail(player.Email)) {
                setEmailError('Toto nevypadá jako emailová adresa')
            }
        }
    }, [emailRequired, player.Email, player.FullName, showErrors])

    return (
        <div className="player">
            <div className="player__headline">
                <Heading headline={'Hráč ' + ord} weight={4} />
                {players.length > 1
                    ? <CiCircleRemove className='player__headline__icon' color='#aa0000' title='Odebrat hráče' size='25' onClick={ () => removePlayer(player.Id)} />
                    : ''
                }
            </div>
            <div className="player__name">
                <Input
                    label="Jméno a příjmení"
                    value={player.FullName || ''}
                    setValue={(e) => setPlayerFullName(e.target.value)}
                    type="text"
                    required={true}
                    errorMessage={nameError}
                />
                <Input
                    label="Přezdívka"
                    value={player.Name || ''}
                    setValue={(e) => setPlayerName(e.target.value)}
                    type="text"
                    required={false}
                    errorMessage=''
                />
                <Input
                    label="Email"
                    value={player.Email || '' }
                    setValue={(e) => setEmail(e.target.value)}
                    type="text"
                    required={emailRequired}
                    errorMessage={emailError}
                />
                <Input
                    label="Věk"
                    value={player.Age?.toString() || ''}
                    setValue={(e) => setAge(e.target.value)}
                    type="text"
                    required={false}
                    errorMessage={ageError}
                />
                <Input
                    label="Město"
                    value={player.City || ''}
                    setValue={(e) => setCity(e.target.value)}
                    type="text"
                    required={false}
                    errorMessage=''
                />
            </div>
        </div>
        )
}
